import {NotificationResponsePayload} from '../../../models/api';

export default [
  {
    id: 1,
    statusId: 1,
    statusName: 'Не прочитано',
    topic: 'тема уведомления 1',
    text: 'текст уведомления 1',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 2,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 2',
    text: 'текст уведомления 2',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 3,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 3',
    text: 'текст уведомления 3',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 4,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 4',
    text: 'текст уведомления 4',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 5,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 5',
    text: 'текст уведомления 5',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 6,
    statusId: 1,
    statusName: 'Прочитано',
    topic: 'тема уведомления 6',
    text: 'текст уведомления 6',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 7,
    statusId: 1,
    statusName: 'Не прочитано',
    topic: 'тема уведомления 7',
    text: 'текст уведомления 7',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 8,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 8',
    text: 'текст уведомления 8',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 9,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 9',
    text: 'текст уведомления 9',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 10,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 10',
    text: 'текст уведомления 10',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 11,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 11',
    text: 'текст уведомления 11',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 12,
    statusId: 1,
    statusName: 'Прочитано',
    topic: 'тема уведомления 12',
    text: 'текст уведомления 12',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 13,
    statusId: 1,
    statusName: 'Не прочитано',
    topic: 'тема уведомления 13',
    text: 'текст уведомления 13',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 14,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 14',
    text: 'текст уведомления 14',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 15,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 15',
    text: 'текст уведомления 15',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 16,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 16',
    text: 'текст уведомления 16',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 17,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 17',
    text: 'текст уведомления 17',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 18,
    statusId: 1,
    statusName: 'Прочитано',
    topic: 'тема уведомления 18',
    text: 'текст уведомления 18',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 19,
    statusId: 1,
    statusName: 'Не прочитано',
    topic: 'тема уведомления 19',
    text: 'текст уведомления 19',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 20,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 20',
    text: 'текст уведомления 20',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 21,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 21',
    text: 'текст уведомления 21',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 22,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 22',
    text: 'текст уведомления 22',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 23,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 23',
    text: 'текст уведомления 23',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 24,
    statusId: 1,
    statusName: 'Прочитано',
    topic: 'тема уведомления 24',
    text: 'текст уведомления 24',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 25,
    statusId: 1,
    statusName: 'Не прочитано',
    topic: 'тема уведомления 25',
    text: 'текст уведомления 25',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 26,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 26',
    text: 'текст уведомления 26',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 27,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 27',
    text: 'текст уведомления 27',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 28,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 28',
    text: 'текст уведомления 28',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 29,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 29',
    text: 'текст уведомления 29',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 30,
    statusId: 1,
    statusName: 'Прочитано',
    topic: 'тема уведомления 30',
    text: 'текст уведомления 30',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 31,
    statusId: 1,
    statusName: 'Не прочитано',
    topic: 'тема уведомления 31',
    text: 'текст уведомления 31',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 32,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 32',
    text: 'текст уведомления 32',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 33,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 33',
    text: 'текст уведомления 33',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 34,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 34',
    text: 'текст уведомления 34',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 35,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 35',
    text: 'текст уведомления 35',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 36,
    statusId: 1,
    statusName: 'Прочитано',
    topic: 'тема уведомления 36',
    text: 'текст уведомления 36',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 37,
    statusId: 1,
    statusName: 'Не прочитано',
    topic: 'тема уведомления 37',
    text: 'текст уведомления 37',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 38,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 38',
    text: 'текст уведомления 38',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 39,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 39',
    text: 'текст уведомления 39',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 40,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 40',
    text: 'текст уведомления 40',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 41,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 41',
    text: 'текст уведомления 41',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 42,
    statusId: 1,
    statusName: 'Прочитано',
    topic: 'тема уведомления 42',
    text: 'текст уведомления 42',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 43,
    statusId: 1,
    statusName: 'Не прочитано',
    topic: 'тема уведомления 43',
    text: 'текст уведомления 43',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 44,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 44',
    text: 'текст уведомления 44',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 45,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 45',
    text: 'текст уведомления 45',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 46,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 46',
    text: 'текст уведомления 46',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 47,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 47',
    text: 'текст уведомления 47',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 48,
    statusId: 1,
    statusName: 'Прочитано',
    topic: 'тема уведомления 48',
    text: 'текст уведомления 48',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 49,
    statusId: 1,
    statusName: 'Не прочитано',
    topic: 'тема уведомления 49',
    text: 'текст уведомления 49',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 50,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 50',
    text: 'текст уведомления 50',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 51,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 51',
    text: 'текст уведомления 51',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 52,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 52',
    text: 'текст уведомления 52',
    dateTime: '2020-01-30T14:47Z',
  },
  {
    id: 53,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 53',
    text: 'текст уведомления 53 (contact)',
    dateTime: '2020-01-30T14:47Z',
    referenceType: 'contact',
  },
  {
    id: 54,
    statusId: 1,
    statusName: 'Прочитано',
    topic: 'тема уведомления 54',
    text: 'текст уведомления 54 (ecard)',
    dateTime: '2020-01-30T14:47Z',
    referenceType: 'ecard',
  },
  {
    id: 55,
    statusId: 1,
    statusName: 'Не прочитано',
    topic: 'тема уведомления 55',
    text: 'текст уведомления 55 (socHelp #0538)',
    dateTime: '2020-01-30T14:47Z',
    referenceType: 'socHelp',
    referenceId: '0538',
  },
  {
    id: 56,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 56',
    text: 'текст уведомления 56 (news #133)',
    dateTime: '2020-01-30T14:47Z',
    referenceType: 'news',
    referenceId: '133',
  },
  {
    id: 57,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 57',
    text: 'текст уведомления 57 (poll #1)',
    dateTime: '2020-01-30T14:47Z',
    referenceType: 'poll',
    referenceId: '1',
  },
  {
    id: 58,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 58',
    text: 'текст уведомления 58 (request #111)',
    dateTime: '2020-01-30T14:47Z',
    referenceType: 'request',
    referenceId: '111',
  },
  {
    id: 59,
    statusId: 2,
    statusName: 'Прочитано',
    topic: 'тема уведомления 59',
    text: 'текст уведомления 59 (application #159)',
    dateTime: '2020-01-30T14:47Z',
    referenceType: 'application',
    referenceId: '159',
  },
  {
    id: 60,
    statusId: 1,
    statusName: 'Прочитано',
    topic: 'тема уведомления 60',
    text: 'текст уведомления 60 (usc)',
    dateTime: '2020-01-30T14:47Z',
    referenceType: 'usc',
  },
] as NotificationResponsePayload[];
